import { Text, VStack } from '@vidahealth/vida-ui';
import { View } from 'react-native';

/**
 * Private to ProgramOverview — a simple bulleted list for program features and
 * acknowledgements. A small dot aligned to the first text line, matching the
 * vida-design-system onboarding demo.
 */
export function BulletList({ items }: { items: string[] }) {
  return (
    <VStack space='sm'>
      {items.map((item) => (
        <View key={item} className='flex-row items-start gap-3'>
          <View className='mt-[9px] h-[5px] w-[5px] rounded-full bg-typography-700' />
          <Text size='md' className='flex-1 text-typography-900'>
            {item}
          </Text>
        </View>
      ))}
    </VStack>
  );
}
